import React from 'react';
import { Col, Row } from 'reactstrap';

// img
import { useTranslation } from 'react-i18next';

const NoUserFound = ({Nouser}) => {
    const { t } = useTranslation();

    return (
        <div className='error-color' style={{ height: "100vh" }}>
            <Row className='d-flex justify-content-center align-items-center page1-bg-90vh m-0'>
                <Col sm={9} xl={5} className='h-100 d-flex flex-column justify-content-center align-items-center'>
                    <img src={Nouser} alt='NoUserFound' className='img-fluid pb-5 mb-5' width={250} />
                    <p className='fw-bold fs-5 m-0 error-color-title'>{t('noUser.0')}</p>
                </Col>
            </Row>
        </div>
    );
};

export default NoUserFound;
